import { useEffect } from 'react';
import { openPlanStream } from '@/lib/planStream';
import { usePlansStore } from '@/stores/plansStore';

/** Follows one plan (or, with null, the tenant's list) over the plans stream while mounted. */
export function usePlanStream(planId: string | null): void {
  const apply = usePlansStore((s) => s.applyStreamMessage);
  useEffect(() => openPlanStream(planId === null ? {} : { planId }, apply), [planId, apply]);
}
